import React from 'react';
import { EXTERNAL_URLS } from 'consts/externalUrls';
import { IconsBox, MainBox, buttonStyles } from './FollowCurology.style';
import { CtaButton } from 'components/global/CtaButton';

export const FollowCurology = () => (
  <MainBox>
    <IconsBox>
      <CtaButton
        buttonText={'Twitter'}
        link={EXTERNAL_URLS.twitter}
        isExternal={true}
        css={buttonStyles}
      />
      <CtaButton
        buttonText={'Snapchat'}
        link={EXTERNAL_URLS.snapchat}
        isExternal={true}
        css={buttonStyles}
      />
      <CtaButton
        buttonText={'Instagram'}
        link={EXTERNAL_URLS.instagram}
        isExternal={true}
        css={buttonStyles}
      />
      <CtaButton
        buttonText={'Facebook'}
        link={EXTERNAL_URLS.facebook}
        isExternal={true}
        css={buttonStyles}
      />
      <CtaButton
        buttonText={'YouTube'}
        link={EXTERNAL_URLS.youtube}
        isExternal={true}
        css={buttonStyles}
      />
      <CtaButton
        buttonText={'Pinterest'}
        link={EXTERNAL_URLS.pinterest}
        isExternal={true}
        css={buttonStyles}
      />
    </IconsBox>
  </MainBox>
);
